import request from './request';
/**
 *  获取标签列表
 */
export function getLabelList(params) {
    return request('/tags/list', {
        method: 'POST',
        params,
    });
}

/**
 *  获取全部标签分类
 */
export function getTags(params) {
    return request('/tags-type/list-all', {
        method: 'POST',
        params,
    });
}

/**
 *  获取详情
 */
export function getLabelDetail(id) {
    return request(`/tags/${id}`, {
        method: 'GET',
    });
}

/**
 *  获取历史记录
 */
export function getLabelHistory(id, params) {
    return request(`/tags/record/${id}`, {
        method: 'GET',
        params,
    });
}

/**
 *  启用/禁用
 */
export function changeActive(id, params) {
    return request(`/tags/active/${id}`, {
        method: 'PUT',
        params,
    });
}
/**
 *  添加标签
 */
export function addNewLabel(params) {
    return request('/tags/', {
        method: 'POST',
        params,
    });
}
/**
 *  编辑标签
 */
export function editLabel(id, params) {
    return request(`/tags/${id}`, {
        method: 'PATCH',
        params,
    });
}
/**
 *  重新计算
 */
export function getRecalculate(id, tagId) {
    return request(`/tags/recalculate/${id}/${tagId}`, {
        method: 'GET',
    });
}
/**
 *  获取标签模版分类
 */
export function getTagsModel() {
    return request('/tags/model-type', {
        method: 'GET',
    });
}
/**
 *  获取可选标签
 */
export function getTagsByModel(modelTypeId) {
    return request(`/tags/model/${modelTypeId}`, {
        method: 'GET',
    });
}
/**
 *  设置标签模板引导
 */
export function setTagsGuide() {
    return request('/user/info/guide-tags-model', {
        method: 'GET',
    });
}
/**
 *  删除标签
 */
export function deleteLabel(tagId) {
    return request(`/tags/delete/${tagId}`, {
        method: 'DELETE',
    });
}

/**
 *  模糊搜索手工标签
 */
export function tagsTreeManual(params) {
    return request('/tags-type/tags-tree/manual', {
        method: 'GET',
        params,
    });
}
/**
 *  为客户添加标签
 */
export function addCustomerTag(params) {
    return request('/tags/customer/add', {
        method: 'POST',
        params,
    });
}
/**
 *  根据客户id和门店id获取标签
 */
export function addCustomerTagInfo(params) {
    return request('/tags/customer/list', {
        method: 'POST',
        params,
    });
}
/**
 *  删除客户手工标签
 */
export function deleteCustomerTag(params) {
    return request('/tags/customer/delete', {
        method: 'DELETE',
        params,
    });
}
